import surfaceOptions from './surface-options.esm.js';

var surfaceColorOptionList = Object.keys(surfaceOptions.color);

export { surfaceColorOptionList };
//# sourceMappingURL=types.esm.js.map
